import { createFileRoute } from '@tanstack/react-router';

import { bankAccountAutomaticPixScreen, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Painel do Pix Automático (`router.tsx:520-529`): irmã do detalhe, fora da barra de abas, só com a flag `AUTOMATIC_PIX`.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/')({
  staticData: { screen: bankAccountAutomaticPixScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountAutomaticPixScreen'),
});
